import React, { useEffect, useMemo, useState } from "react";
import styles from "./AllInfoAvitoContainer.module.scss";
import Title from "../../ui/Title/Title";
import AvitoIcon from "../../assets/icons/AvitoIcon";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../ui/Button/Button";
import { ClipLoader } from "react-spinners";
import { LinkSlashIcon } from "../../assets/icons/LinkSlashIcon";
import { Checkbox } from "../../ui/Checkbox/Checkbox";
import { useNavigate } from "react-router-dom";
import Select from "../../ui/Select/Select";
import Switcher from "../../ui/Switcher/Switcher";
import { ModalAvitoIntegrationForm } from "../ModalAvitoIntegrationForm/ModalAvitoIntegrationForm";
import {
  setNewAvito,
  setUpdateAvito,
  setUpdateAvitoData,
} from "../../store/slices/avitoSlice";
import Chip from "../../ui/Chip/Chip";
import {
  formatPhoneNumber,
  formatPhonesNumber,
} from "../../utils/methods/phoneFormatter";
import { ArrowsRotate } from "../../assets/icons/ArrowsRotate.js";
import {
  deactivateAvito,
  synchronizationAvito,
} from "../../utils/api/actions/integrations/avito.js";
import { ErrorComponent } from "../ErrorComponent/ErrorComponent.js";

export const AllInfoAvitoContainer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { activeAvito, newAvito, updateAvito, isErrorAvito } = useSelector(
    (state) => state?.avito
  );
  const { dataAssistants } = useSelector((state) => state?.assistant);

  const initialAvitoData = useMemo(
    () => ({
      userId: activeAvito?.userId,
      clientId: activeAvito?.clientId,
      assistantId: activeAvito?.assistantId,
      webHookActive: activeAvito?.webHookActive,
    }),
    [activeAvito]
  );

  const isAssistantActive = activeAvito?.webHookActive;

  const [visibleModal, setVisibleModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingSync, setLoadingSync] = useState(false);
  const [isSwitchOn, setIsSwitchOn] = useState(isAssistantActive);
  const [updatedAvitoData, setUpdatedAvitoData] = useState(initialAvitoData);
  const [checked, setChecked] = useState(false);

  const isEmptyObject = (obj) => obj && Object.keys(obj).length > 0;

  useEffect(() => {
    if (activeAvito) {
      setIsSwitchOn(activeAvito.webHookActive);
    }
  }, [activeAvito]);

  useEffect(() => {
    if (!updateAvito) {
      setUpdatedAvitoData(initialAvitoData);
      setIsSwitchOn(initialAvitoData.webHookActive);
    }
  }, [updateAvito, initialAvitoData]);

  useEffect(() => {
    if (activeAvito && activeAvito.assistantID) {
      setUpdatedAvitoData((prevData) => ({
        ...prevData,
        assistantId: activeAvito.assistantID,
      }));
    }
  }, [activeAvito]);

  useEffect(() => {
    if (updateAvito) {
      dispatch(setUpdateAvitoData(updatedAvitoData));
    }
  }, [updateAvito, updatedAvitoData, dispatch]);

  useEffect(() => {
    if (isEmptyObject(newAvito)) {
      setVisibleModal(true);
    }
  }, [newAvito]);

  const assistantName =
    updatedAvitoData?.assistantId !== undefined
      ? dataAssistants?.find(
          (assistant) => assistant.id === updatedAvitoData?.assistantId
        )?.name || "Ассистент не найден"
      : dataAssistants?.find(
          (assistant) => assistant.id === activeAvito?.assistantID
        )?.name || "Ассистент не найден";

  const handleToggle = () => {
    const newSwitchState = !isSwitchOn;
    setIsSwitchOn(newSwitchState);

    dispatch(setUpdateAvito(true));
    setUpdatedAvitoData((prevData) => ({
      ...prevData,
      webHookActive: newSwitchState,
    }));
  };

  const selectObserver = (val) => {
    if (val && val !== "00000000-0000-0000-0000-000000000000") {
      dispatch(setUpdateAvito(true));
      setUpdatedAvitoData((prevData) => ({
        ...prevData,
        assistantId: val,
      }));
    }
  };

  const handleDeactivate = () => {
    localStorage.removeItem("dataAvito");
    let data = {
      userId: activeAvito.userId,
      clientId: activeAvito.clientId,
      withRemove: checked,
    };
    dispatch(deactivateAvito(data, setLoading, navigate));
  };

  const handlerCloseModal = () => {
    setVisibleModal(false);
    dispatch(setNewAvito(null));
  };

  const handleStartInit = () => {
    dispatch(
      setNewAvito({
        userId: "",
        clientId: "",
        clientSecret: "",
      })
    );
    setVisibleModal(true);
  };

  const DataItem = ({ title, data, chip }) => {
    return (
      <div className={styles.dataItemContainer}>
        <div className={styles.dataItemContainerFlex}>
          <label className={styles.title}>{title}</label>
          {chip && (
            <Chip
              classNameChip={styles.chipContainer}
              active={isSwitchOn}
              title={isSwitchOn ? "Активен" : "Не активен"}
            />
          )}
        </div>
        <label className={styles.data}>{data}</label>
      </div>
    );
  };

  const handleSynchronization = () => {
    let data = {
      userId: activeAvito.userId,
      clientId: activeAvito.clientId,
    };
    dispatch(synchronizationAvito(data, setLoadingSync));
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        {!isErrorAvito && (
          <div className={styles.headerInfoContainer}>
            <div className={styles.headerInfoContainerTitle}>
              <Title title={activeAvito?.name} className={styles.title} />
              <AvitoIcon size={20} />
            </div>
            {activeAvito && !activeAvito?.active ? (
              <Button
                leftIcon={
                  loading ? (
                    <ClipLoader size={20} color="white" />
                  ) : (
                    <LinkSlashIcon />
                  )
                }
                titleClassName={styles.buttonTitle}
                className={styles.button}
                title={loading ? "Подождите" : "Привязать"}
                onClick={handleStartInit}
              />
            ) : (
              <>
                <Button
                  leftIcon={
                    loading ? (
                      <ClipLoader size={20} color="white" />
                    ) : (
                      <LinkSlashIcon />
                    )
                  }
                  titleClassName={
                    loading ? styles.activeButtonTitle : styles.buttonTitle
                  }
                  className={loading ? styles.activeButton : styles.button}
                  title={loading ? "Подождите" : "Отвязать"}
                  onClick={handleDeactivate}
                />
                <Checkbox
                  value={checked}
                  onChange={(e) => setChecked(e.target.checked)}
                />
              </>
            )}
            {activeAvito && activeAvito?.active && (
              <Button
                leftIcon={
                  loadingSync ? (
                    <ClipLoader size={20} color="white" />
                  ) : (
                    <ArrowsRotate size={20} fill="white" />
                  )
                }
                titleClassName={styles.buttonSyncTitle}
                className={styles.buttonSync}
                title={loadingSync ? "Подождите" : "Синхронизировать"}
                onClick={handleSynchronization}
              />
            )}
          </div>
        )}
      </div>

      {isErrorAvito && (
        <ErrorComponent
          title={"Произошла ошибка при получении данных Avito"}
          text={
            "При получении данных о вашем аккаунте произошла ошибка. Вы можете вернуться на страницу интеграций и попробовать открыть страницу еще раз."
          }
          buttonTitle={"Вернуться на страницу интеграций"}
          path={"/integration"}
        />
      )}

      {activeAvito && !isErrorAvito && (
        <>
          <div className={styles.rowData}>
            <DataItem title={"Avito id"} data={activeAvito.externalAvitoId} />
            {activeAvito && (
              <DataItem
                title={"Ссылка на профиль"}
                data={
                  <a
                    className={styles.link}
                    href={activeAvito.profileUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {activeAvito.profileUrl}
                  </a>
                }
              />
            )}
          </div>
          {(activeAvito.phone || activeAvito.phones) && (
            <div className={styles.rowData}>
              {activeAvito.phone && (
                <DataItem
                  title={"Номер телефона"}
                  data={formatPhoneNumber(activeAvito.phone)}
                />
              )}
              {activeAvito.phones && (
                <DataItem
                  title={"Номера телефонов"}
                  data={
                    <pre className={styles.phones}>
                      {formatPhonesNumber(activeAvito.phones)}
                    </pre>
                  }
                />
              )}
            </div>
          )}
          <div className={styles.rowData}>
            <DataItem title={"Client id"} data={activeAvito.clientId} />

            <DataItem title={"Client secret"} data={activeAvito.clientSecret} />
          </div>
          <div className={styles.rowData}>
            <DataItem title={"Email"} data={activeAvito.email} />
          </div>
        </>
      )}

      {!isErrorAvito && (
        <div className={styles.headerAssistantContainer}>
          <DataItem
            title={`Ассистент`}
            chip={true}
            data={
              <Select
                containerStyle={styles.containerSelect}
                labelStyle={styles.labelSelect}
                dataSelect={dataAssistants}
                selectObserver={selectObserver}
                nameSelectedOption={assistantName}
              />
            }
          />
          <div>
            <DataItem
              title={"Статус"}
              data={
                <Switcher
                  switchStyle={styles.switchContainer}
                  bool={isSwitchOn}
                  onToggle={handleToggle}
                />
              }
            />
          </div>
        </div>
      )}
      {newAvito && !isErrorAvito && (
        <ModalAvitoIntegrationForm
          visible={visibleModal}
          handlerClose={handlerCloseModal}
        />
      )}
    </div>
  );
};
